import { render, staticRenderFns } from "./WQtypeRadio.vue?vue&type=template&id=50e6cc79&"
import script from "./WQtypeRadio.vue?vue&type=script&lang=ts&"
export * from "./WQtypeRadio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports